// Placeholder address used when a contact or guest has no email (the "No Email" checkbox). Each one is unique, so it
// never matches an existing account and the contact is never linked to someone else (see useExistingAccountConfirm).
export function generateNoEmailAddress(): string {
  const randomNumber = Math.floor(100000000 + Math.random() * 900000000)
  return `NoEmail_${randomNumber}@mailinator.com`
}
